import { FC, useMemo } from "react";

import { useGetLabelGroupListForWorkspace } from "@/domain/label/hooks/api/use-get-label-group-list-for-workspace";

import { type LabelAssignmentContext } from "./label-assignment-context";
import { LabelGroupListItem } from "./label-group-list-item";

interface LabelGroupListProps {
  workspaceId: string;
  labelAssignmentContext?: LabelAssignmentContext;
}

export const LabelGroupList: FC<LabelGroupListProps> = ({ workspaceId, labelAssignmentContext }) => {
  const { labelGroupList } = useGetLabelGroupListForWorkspace({ workspaceId });

  const sortedLabelGrouplist = useMemo(() => {
    return labelGroupList.slice().sort((a, b) => {
      if (!a || !b) {
        return 0;
      }
      return a.title.localeCompare(b.title);
    });
  }, [labelGroupList]);

  return (
    <div className="flex flex-col gap-1">
      {sortedLabelGrouplist.map((group) => (
        <LabelGroupListItem
          key={group.id}
          labelGroupId={group.id}
          workspaceId={workspaceId}
          labelAssignmentContext={labelAssignmentContext}
        />
      ))}
    </div>
  );
};
